export const MODULE_NAME = 'advertorials';
export const LANDING_PAGES_ROUTE = `/${MODULE_NAME}`;
